/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { InspectionParameters } from "../../../../gen/surface_scan/inspection_parameters";
import { SettingsManager } from "../../../../gen/surface_scan/settings_manager";
import { CameraSettings, PhotoFormatSettings } from "../../mission_camera_settings";
import { UiStatsView } from "../../ui_workflow";

export const protobufPackage = "skills";

/** Arguments for performing a surface scan */
export interface SurfaceScanActionArgs {
  /** Parameters to start inspection */
  inspectionParameters:
    | InspectionParameters
    | undefined;
  /** Manager for scan settings */
  settingsManager:
    | SettingsManager
    | undefined;
  /** Keys for scan settings */
  settingsKeys: string[];
  scanSkillStateId: string;
  resumeScan: boolean;
  siteName: string;
  /** Name for saving the scan. */
  saveName: string;
  saveUclock: number;
  stats: UiStatsView | undefined;
  scanModeLabel: string;
  /** General camera settings like exposure time, iso, etc. */
  cameraSettings:
    | CameraSettings
    | undefined;
  /** Photo formats to be captured. */
  photoFormatSettings: PhotoFormatSettings | undefined;
}

export interface SurfaceScanResultData {
}

export interface SurfaceScanActionStateData {
  photoCount: number;
  photosCompleted: number;
  timeRemaining: number;
  savedStateFingerprint: string;
}

function createBaseSurfaceScanActionArgs(): SurfaceScanActionArgs {
  return {
    inspectionParameters: undefined,
    settingsManager: undefined,
    settingsKeys: [],
    scanSkillStateId: "",
    resumeScan: false,
    siteName: "",
    saveName: "",
    saveUclock: 0,
    stats: undefined,
    scanModeLabel: "",
    cameraSettings: undefined,
    photoFormatSettings: undefined,
  };
}

export const SurfaceScanActionArgs = {
  encode(message: SurfaceScanActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.inspectionParameters !== undefined) {
      InspectionParameters.encode(message.inspectionParameters, writer.uint32(10).fork()).ldelim();
    }
    if (message.settingsManager !== undefined) {
      SettingsManager.encode(message.settingsManager, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.settingsKeys) {
      writer.uint32(34).string(v!);
    }
    if (message.scanSkillStateId !== "") {
      writer.uint32(42).string(message.scanSkillStateId);
    }
    if (message.resumeScan === true) {
      writer.uint32(48).bool(message.resumeScan);
    }
    if (message.siteName !== "") {
      writer.uint32(58).string(message.siteName);
    }
    if (message.saveName !== "") {
      writer.uint32(66).string(message.saveName);
    }
    if (message.saveUclock !== 0) {
      writer.uint32(72).int64(message.saveUclock);
    }
    if (message.stats !== undefined) {
      UiStatsView.encode(message.stats, writer.uint32(82).fork()).ldelim();
    }
    if (message.scanModeLabel !== "") {
      writer.uint32(90).string(message.scanModeLabel);
    }
    if (message.cameraSettings !== undefined) {
      CameraSettings.encode(message.cameraSettings, writer.uint32(98).fork()).ldelim();
    }
    if (message.photoFormatSettings !== undefined) {
      PhotoFormatSettings.encode(message.photoFormatSettings, writer.uint32(106).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SurfaceScanActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSurfaceScanActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.inspectionParameters = InspectionParameters.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.settingsManager = SettingsManager.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.settingsKeys.push(reader.string());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.scanSkillStateId = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.resumeScan = reader.bool();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.siteName = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.saveName = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.saveUclock = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.stats = UiStatsView.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.scanModeLabel = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.cameraSettings = CameraSettings.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.photoFormatSettings = PhotoFormatSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SurfaceScanActionArgs {
    return {
      inspectionParameters: isSet(object.inspectionParameters)
        ? InspectionParameters.fromJSON(object.inspectionParameters)
        : undefined,
      settingsManager: isSet(object.settingsManager) ? SettingsManager.fromJSON(object.settingsManager) : undefined,
      settingsKeys: globalThis.Array.isArray(object?.settingsKeys)
        ? object.settingsKeys.map((e: any) => globalThis.String(e))
        : [],
      scanSkillStateId: isSet(object.scanSkillStateId) ? globalThis.String(object.scanSkillStateId) : "",
      resumeScan: isSet(object.resumeScan) ? globalThis.Boolean(object.resumeScan) : false,
      siteName: isSet(object.siteName) ? globalThis.String(object.siteName) : "",
      saveName: isSet(object.saveName) ? globalThis.String(object.saveName) : "",
      saveUclock: isSet(object.saveUclock) ? globalThis.Number(object.saveUclock) : 0,
      stats: isSet(object.stats) ? UiStatsView.fromJSON(object.stats) : undefined,
      scanModeLabel: isSet(object.scanModeLabel) ? globalThis.String(object.scanModeLabel) : "",
      cameraSettings: isSet(object.cameraSettings) ? CameraSettings.fromJSON(object.cameraSettings) : undefined,
      photoFormatSettings: isSet(object.photoFormatSettings)
        ? PhotoFormatSettings.fromJSON(object.photoFormatSettings)
        : undefined,
    };
  },

  toJSON(message: SurfaceScanActionArgs): unknown {
    const obj: any = {};
    if (message.inspectionParameters !== undefined) {
      obj.inspectionParameters = InspectionParameters.toJSON(message.inspectionParameters);
    }
    if (message.settingsManager !== undefined) {
      obj.settingsManager = SettingsManager.toJSON(message.settingsManager);
    }
    if (message.settingsKeys?.length) {
      obj.settingsKeys = message.settingsKeys;
    }
    if (message.scanSkillStateId !== "") {
      obj.scanSkillStateId = message.scanSkillStateId;
    }
    if (message.resumeScan === true) {
      obj.resumeScan = message.resumeScan;
    }
    if (message.siteName !== "") {
      obj.siteName = message.siteName;
    }
    if (message.saveName !== "") {
      obj.saveName = message.saveName;
    }
    if (message.saveUclock !== 0) {
      obj.saveUclock = Math.round(message.saveUclock);
    }
    if (message.stats !== undefined) {
      obj.stats = UiStatsView.toJSON(message.stats);
    }
    if (message.scanModeLabel !== "") {
      obj.scanModeLabel = message.scanModeLabel;
    }
    if (message.cameraSettings !== undefined) {
      obj.cameraSettings = CameraSettings.toJSON(message.cameraSettings);
    }
    if (message.photoFormatSettings !== undefined) {
      obj.photoFormatSettings = PhotoFormatSettings.toJSON(message.photoFormatSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SurfaceScanActionArgs>, I>>(base?: I): SurfaceScanActionArgs {
    return SurfaceScanActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SurfaceScanActionArgs>, I>>(object: I): SurfaceScanActionArgs {
    const message = createBaseSurfaceScanActionArgs();
    message.inspectionParameters = (object.inspectionParameters !== undefined && object.inspectionParameters !== null)
      ? InspectionParameters.fromPartial(object.inspectionParameters)
      : undefined;
    message.settingsManager = (object.settingsManager !== undefined && object.settingsManager !== null)
      ? SettingsManager.fromPartial(object.settingsManager)
      : undefined;
    message.settingsKeys = object.settingsKeys?.map((e) => e) || [];
    message.scanSkillStateId = object.scanSkillStateId ?? "";
    message.resumeScan = object.resumeScan ?? false;
    message.siteName = object.siteName ?? "";
    message.saveName = object.saveName ?? "";
    message.saveUclock = object.saveUclock ?? 0;
    message.stats = (object.stats !== undefined && object.stats !== null)
      ? UiStatsView.fromPartial(object.stats)
      : undefined;
    message.scanModeLabel = object.scanModeLabel ?? "";
    message.cameraSettings = (object.cameraSettings !== undefined && object.cameraSettings !== null)
      ? CameraSettings.fromPartial(object.cameraSettings)
      : undefined;
    message.photoFormatSettings = (object.photoFormatSettings !== undefined && object.photoFormatSettings !== null)
      ? PhotoFormatSettings.fromPartial(object.photoFormatSettings)
      : undefined;
    return message;
  },
};

function createBaseSurfaceScanResultData(): SurfaceScanResultData {
  return {};
}

export const SurfaceScanResultData = {
  encode(_: SurfaceScanResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SurfaceScanResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSurfaceScanResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SurfaceScanResultData {
    return {};
  },

  toJSON(_: SurfaceScanResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SurfaceScanResultData>, I>>(base?: I): SurfaceScanResultData {
    return SurfaceScanResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SurfaceScanResultData>, I>>(_: I): SurfaceScanResultData {
    const message = createBaseSurfaceScanResultData();
    return message;
  },
};

function createBaseSurfaceScanActionStateData(): SurfaceScanActionStateData {
  return { photoCount: 0, photosCompleted: 0, timeRemaining: 0, savedStateFingerprint: "" };
}

export const SurfaceScanActionStateData = {
  encode(message: SurfaceScanActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.photoCount !== 0) {
      writer.uint32(8).int32(message.photoCount);
    }
    if (message.photosCompleted !== 0) {
      writer.uint32(16).int32(message.photosCompleted);
    }
    if (message.timeRemaining !== 0) {
      writer.uint32(29).float(message.timeRemaining);
    }
    if (message.savedStateFingerprint !== "") {
      writer.uint32(34).string(message.savedStateFingerprint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SurfaceScanActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSurfaceScanActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.photoCount = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.photosCompleted = reader.int32();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.timeRemaining = reader.float();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.savedStateFingerprint = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SurfaceScanActionStateData {
    return {
      photoCount: isSet(object.photoCount) ? globalThis.Number(object.photoCount) : 0,
      photosCompleted: isSet(object.photosCompleted) ? globalThis.Number(object.photosCompleted) : 0,
      timeRemaining: isSet(object.timeRemaining) ? globalThis.Number(object.timeRemaining) : 0,
      savedStateFingerprint: isSet(object.savedStateFingerprint) ? globalThis.String(object.savedStateFingerprint) : "",
    };
  },

  toJSON(message: SurfaceScanActionStateData): unknown {
    const obj: any = {};
    if (message.photoCount !== 0) {
      obj.photoCount = Math.round(message.photoCount);
    }
    if (message.photosCompleted !== 0) {
      obj.photosCompleted = Math.round(message.photosCompleted);
    }
    if (message.timeRemaining !== 0) {
      obj.timeRemaining = message.timeRemaining;
    }
    if (message.savedStateFingerprint !== "") {
      obj.savedStateFingerprint = message.savedStateFingerprint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SurfaceScanActionStateData>, I>>(base?: I): SurfaceScanActionStateData {
    return SurfaceScanActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SurfaceScanActionStateData>, I>>(object: I): SurfaceScanActionStateData {
    const message = createBaseSurfaceScanActionStateData();
    message.photoCount = object.photoCount ?? 0;
    message.photosCompleted = object.photosCompleted ?? 0;
    message.timeRemaining = object.timeRemaining ?? 0;
    message.savedStateFingerprint = object.savedStateFingerprint ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
